import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VALUE, UNLIMITED, NO, YES, NONE } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Project = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        projectModuleAccess,
        projects,
        projectsValue,
        subProjects,
        subProjectsValue,
        projectTeamMembers,
        projectTeamMembersValue,
    } = settings

    return (
        <Collapse
            show={show}
            title={lang.project}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.projectModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={projectModuleAccess === NO}
                            onChange={() => onChange({ projectModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={projectModuleAccess === YES}
                            onChange={() => onChange({ projectModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.projects}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={projects === 1}
                            onChange={() => onChange({ projects: 1 })}
                            title="1"
                        />
                        <RadioButton
                            checked={projects === VALUE}
                            onChange={() => onChange({ projects: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={projectsValue}
                                    onChange={(e) => onChange({ projectsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={projects === UNLIMITED}
                            onChange={() => onChange({ projects: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.subProjects}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={subProjects === NONE}
                            onChange={() => onChange({ subProjects: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={subProjects === VALUE}
                            onChange={() => onChange({ subProjects: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={subProjectsValue}
                                    onChange={(e) => onChange({ subProjectsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={subProjects === UNLIMITED}
                            onChange={() => onChange({ subProjects: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.projectTeamMembers}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={projectTeamMembers === 1}
                            onChange={() => onChange({ projectTeamMembers: 1 })}
                            title="1"
                        />
                        <RadioButton
                            checked={projectTeamMembers === VALUE}
                            onChange={() => onChange({ projectTeamMembers: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={projectTeamMembersValue}
                                    onChange={(e) => onChange({ projectTeamMembersValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={projectTeamMembers === UNLIMITED}
                            onChange={() => onChange({ projectTeamMembers: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Project
